<template>
  <span class="btn-toggle-type" @click.prevent="toggle">
    <atomic-icon :id="icon" />
  </span>
</template>

<script setup lang="ts">
  const hide = defineModel<boolean>();

  const icon = computed(() => (hide.value ? 'eye-visibility' : 'eye-invisible'));

  const toggle = (): void => {
    hide.value = !hide.value;
  };
</script>

<style src="~/assets/styles/components/button/toggle-type.scss" lang="scss" />
